module.exports = __webpack_public_path__ + "i18n/zh-TW.a549614ffbfc6768903a5fa57b54ca89.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/zh-TW.json
// module id = 1067
// module chunks = 60